// eslint-disable-next-line import/prefer-default-export
export const getDimensionsImage = (file: File): Promise<HTMLImageElement> =>
  new Promise<HTMLImageElement>(resolve => {
    const img = new Image();
    const url = window.URL || window.webkitURL;
    const objectUrl = url.createObjectURL(file);
    img.onload = () => {
      url.revokeObjectURL(objectUrl);
      resolve(img);
    };
    img.src = objectUrl;
  });
